<template>
  <div class="projects-layout">

    <div class="left-column">
      <div class="projects-cards">
        <ProjectCard
          v-for="project in filteredProjects"
          :key="project.id"
          :project="project"
        />
      </div>
    </div>


    <div class="right-column">

      <div class="section-filters">
        <h2>Filters</h2>

        <div class="filters">    
          <router-link
            v-for="category in ['All', 'Art', 'Audiovisual', 'Video Game', 'Programming']"
            :key="category"
            :to="{ path: '/projects', query: { filter: category !== 'All' ? category : undefined } }"
            :class="{ 'selected-filter': activeFilter === category }">
            {{ category }}
          </router-link>
        </div>

        <div class="button-advanced-filters">
          <button class="toggle-button" @click="toggleAdvancedFilters">
            <img 
              class="advanced-filters-image" 
              src="/site_assets/ui/fleche.svg" 
              :class="{ 'rotate-up': showAdvancedFilters, 'rotate-down': !showAdvancedFilters }"/>
            {{ showAdvancedFilters ? 'Advanced Filters' : 'Advanced Filters' }}
          </button>
        </div>

        <div class="advanced-filters" v-show="showAdvancedFilters">
          <router-link
            v-for="category in ['Collage', 'GameJam', 'Visual', 'Video Mapping', 'Cover', 'Web', '3D', 'Installation', 'Virtual Reality', 'Mixed Media Animation', 'Photogrammetry', 'Short Movie', 'Drawing', 'BD', 'IMAC', 'Bauhaus University', 'Master ANCV']"
            :key="category"
            :to="{ path: '/projects', query: { filter: category } }"
            :class="{ 'selected-filter': activeFilter === category }">
            {{ category }}
          </router-link>
        </div>
      </div>
      <!-- Liens -->
      
      <div class="links">
        <h2>Links</h2>
        <ul>
          <li><a href="https://www.youtube.com/playlist?list=PLAXr2uj1HfaFyKdHii7ITOrHE2MjPQHiS" target="_blank">✭ project videos on youtube</a></li>
          <li><a href="https://milymew.itch.io/" target="_blank">✭ itch.io</a></li>
          <li><a href="https://www.instagram.com/emilyrosest.art/" target="_blank">✭ instagram</a></li>
          <li><a href="https://milymew.miamo.fr/src/photos.html" target="_blank">✭ photography</a></li>
        </ul>
      </div>
      
      <a href="https://youtu.be/n5BZ5R6Ac24" target="_blank" id="showreel">✭ showreel 2025</a>
      <iframe
          :src="`https://www.youtube.com/embed/n5BZ5R6Ac24`" 
          frameborder="0" 
          allowfullscreen>
      </iframe>
    </div>
  </div>
</template>

  
<script>
import ProjectCard from "../components/ProjectCard.vue";
import projectsData from "../projects.json";

export default {
  components: { ProjectCard },
  data() {
    return {
      projects: projectsData,
      showAdvancedFilters: false,
    };
  },
  computed: {
    activeFilter() {
      return this.$route.query.filter || 'All';
    },
    filteredProjects() {
      if (this.activeFilter === 'All') {
        return [...this.projects].sort((a, b) => b.id - a.id);
      }
      return [...this.projects]
        .filter((project) => project.category.includes(this.activeFilter))
        .sort((a, b) => b.id - a.id);
    },
  },
  methods: {
    toggleAdvancedFilters() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
  },
};
</script>

  
<style scoped>

.projects-layout {
  display: grid;
  grid-template-columns: 4fr 1fr; 
  gap: 20px;
  height: auto; 
}

.left-column {
  overflow: visible; 
}

.projects-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20vw, 1fr));
  gap: 20px;
}

.right-column {
  position: sticky;
  top: 0; 
  align-self: start;
  padding: 20px;
  overflow-y: visible;
  display: flex;
  flex-direction: column;
  z-index: 10;
}



.filters {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 15px;
}

button, a {
  text-decoration: none;
  margin: 1px 0;
  padding: 0;
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-family: "Wremena";
  font-size: 13px;
  text-align: left;
  background-color: white;
}

button:hover, a:hover {
  color: var(--color-rose);
  border-bottom: 2px solid var(--color-rose);
}

.selected-filter {
  color: var(--color-rose);
  font-weight: bold;
  border-bottom: 2px solid var(--color-rose);
}

.toggle-button {
  padding: 0;
  border: none;
  cursor: pointer;
  font-style: italic;
}

.advanced-filters {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 20px;
}

.button-advanced-filters {
  margin: 20px 0;
  display: flex; 
  align-items: center;
  gap: 8px; 
  background-color: white;
}

.advanced-filters-image {
  height: 10px;
  transition: transform 0.3s ease;
}

button.toggle-button:hover {
  border-bottom: none;
}

.rotate-up {
  transform: rotate(90deg); 
}

.rotate-down {
  transform: rotate(0deg); 
}

.links ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.links li {
  margin-bottom: 10px;
  background-color: white;
}

.links a {
  text-decoration: none;
  font-style: italic;
}

#showreel {
  font-size: 20px;
  background-color: white;
  font-style: italic;
}

h2 {
  font-size: 16px;
  padding: 0 0;
  margin: 16px 0;
  background-color: white;
}

  @media (max-width: 768px) {
    h2 {
      font-size: 16px;
      padding-bottom: 5px;
    }

    .projects-layout {
      display: flex;
      flex-direction: column-reverse;
    }

    .button-advanced-filters {
      margin-top: 10px;
    }

    .links li {
      margin-bottom: 0;
      font-size: 13px;
    }

    .right-column {
      position: relative;
    }

    .projects-cards {
      display: flex;
      flex-direction: column;
    }
  }


</style>
